module.exports = __webpack_public_path__ + "img/CalendarBlank.f4f00e49.svg";